import React, { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { toast } from "sonner";
import {
  addNewFAQs,
  fetchFAQsList,
  updateFAQs,
} from "../../services/axios/apiManager";
import { Formik } from "formik";
import { faqValidationSchema } from "./faqValidations";
import { useNavigate } from "react-router-dom";
import { handleErrors } from "../../services/dataManager";
import LoadingSpinner from "../../Components/spinner";

const AddEditFaqModal = ({
  handleCloseAddEditModal,
  showAddEditModal,
  faqCategories,
  selectedFAQ,
  setFaqs,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleAddEditFAQ = async (data) => {
    if (selectedFAQ?.id) {
      const editResponse = await updateFAQs({ id: selectedFAQ.id, ...data });

      if (editResponse?.data?.success) {
        const response = await fetchFAQsList();
        if (response?.data?.data) {
          setFaqs(response.data.data);
        }
        toast.success("FAQ has been updated", { duration: 2000 });
        handleCloseAddEditModal();
      } else {
        handleErrors(editResponse, navigate, "Update FAQ:");
      }
    } else {
      const addResponse = await addNewFAQs(data);
      if (addResponse?.data?.success) {
        const response = await fetchFAQsList();
        if (response?.data?.data) {
          setFaqs(response.data.data);
        }
        toast.success("FAQ has been Added", { duration: 2000 });
        handleCloseAddEditModal();
      } else {
        handleErrors(addResponse, navigate, "Update FAQ:");
      }
    }
  };

  return (
    <Modal
      show={showAddEditModal}
      onHide={handleCloseAddEditModal}
      centered
      className="text-light"
      backdrop="static"
    >
      <Modal.Header closeButton className="bg-dark text-light border-0">
        <Modal.Title className="text-success">
          {selectedFAQ?.id ? "Edit FAQ" : "Add New FAQ"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-light">
        <Formik
          initialValues={{
            category_id: selectedFAQ?.category_id || "",
            question: selectedFAQ?.question || "",
            answer: selectedFAQ?.answer || "",
          }}
          validationSchema={faqValidationSchema}
          onSubmit={async (values) => {
            try {
              setLoading(true);
              if (loading) {
                return;
              }
              await handleAddEditFAQ(values);
            } catch (error) {
              console.log("Error upon Change Password", error);
            } finally {
              setLoading(false);
            }
          }}
        >
          {({
            handleChange,
            setFieldValue,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <div>
              <Form.Group className="mb-3">
                <Form.Label>Category</Form.Label>
                <Form.Select
                  className="bg-dark text-light border-light input-placeholder-light form-control"
                  value={values.category_id}
                  onChange={handleChange("category_id")}
                >
                  <option value="">Select Category</option>
                  {faqCategories?.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.title}
                    </option>
                  ))}
                </Form.Select>
                {errors?.category_id && touched?.category_id ? (
                  <span className="text-danger">{errors?.category_id}</span>
                ) : null}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Question</Form.Label>
                <Form.Control
                  type="text"
                  id="question"
                  required
                  value={values.question}
                  onChange={handleChange("question")}
                  placeholder="Enter question"
                  className="bg-dark text-light border-light"
                />
                {errors?.question && touched?.question ? (
                  <span className="text-danger">{errors?.question}</span>
                ) : null}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Answer</Form.Label>
                <Form.Control
                  type="text"
                  id="answer"
                  required
                  value={values.answer}
                  onChange={handleChange("answer")}
                  placeholder="Enter answer"
                  className="bg-dark text-light border-light"
                />
                {errors?.answer && touched?.answer ? (
                  <span className="text-danger">{errors?.answer}</span>
                ) : null}
              </Form.Group>
              <div class="container-fluid">
                <div class="d-flex justify-content-end">
                  {loading && (
                    <div className="mt-4 mx-2">
                      <LoadingSpinner size={"lg"} />
                    </div>
                  )}
                  <Button
                    className="mt-3 mx-2"
                    variant="secondary"
                    onClick={handleCloseAddEditModal}
                  >
                    Close
                  </Button>
                  <Button
                    variant="success"
                    className="mt-3"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    {selectedFAQ?.id ? "Save Changes" : "Create"}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};
export default AddEditFaqModal;
